module.exports = __webpack_public_path__ + "media/images/NPort_Banner_Dark-af8fef38af5b605428d4f5a71d25b114.jpg";